import { Component } from '@angular/core';
import { ToastrService } from '@core/services/notification/toastr.service';
import { FormGroup, Validators, FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';

import { StorageService } from '@core/services/util/storage.service';
import { UtilityService } from '@core/services/util/utility.service';
import { LoginService } from '@core/services/login/login.service';
import { AuthenticationService } from '@modules/authentication/services/authentication.service';
import { SentryBreadcrumbsService } from '@app/core/services/sentry-breadcrumbs.service';
import { PonchoUIModule } from '@poncho/ui';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { Router } from '@angular/router';

@Component({
    selector: 'app-main-signup',
    templateUrl: './main-signup.component.html',
    styleUrls: ['./main-signup.component.scss'],
    standalone: true,
    imports: [FormsModule, ReactiveFormsModule, MatFormFieldModule, MatInputModule, PonchoUIModule]
})
export class MainSignupComponent {
    signupForm: FormGroup;
    mobileNumber: string;
    btnLoading = false;

    constructor(
        private storageService: StorageService,
        private utilityService: UtilityService,
        private loginService: LoginService,
        private authenticationService: AuthenticationService,
        private toastrService: ToastrService,
        private breadCrumb: SentryBreadcrumbsService,
        private router: Router
    ) {
        const emailRegex = this.utilityService.emailRegex;
        this.mobileNumber = this.storageService.get('phone_number');
        this.signupForm = new FormGroup({
            name: new FormControl('', Validators.compose([Validators.minLength(3)])),
            email: new FormControl('', Validators.compose([Validators.pattern(emailRegex)])),
            password: new FormControl('', Validators.compose([Validators.minLength(6)]))
        });
    }

    signUp() {
        if (!this.signupForm.valid) {
            this.utilityService.markFormFieldsAsTouched(this.signupForm);
            return;
        }

        this.btnLoading = true;

        this.loginService.ensureSessionId().then(() => {
            const name = this.signupForm.value.name,
                email = this.signupForm.value.email,
                password = this.signupForm.value.password;

            this.loginService
                .signUp(name, email, password)
                .toPromise()
                .then((data: any) => {
                    if (data && data.meta) {
                        this.toastrService.openSnackBar(data.meta.message, 'OKAY');
                        if (data.meta.code === 200) {
                            this.breadCrumb.add('auth', 'MainSignupComponent Success 200', null);
                            this.authenticationService.nextStep('otp-verification', 'signup-otp-verification');
                        } else {
                            this.breadCrumb.add('auth', 'MainSignupComponent Success !200', null);
                            this.toastrService.openSnackBar(data.meta.message, 'OKAY');
                        }
                    }
                })
                .catch((error: any) => {
                    this.breadCrumb.add('auth', 'MainSignupComponent Error', { data: error });
                    this.toastrService.openSnackBar(error?.meta?.message, 'OKAY');
                })
                .finally(() => {
                    this.btnLoading = false;
                });
        });
    }

    navigateToTnc() {
        this.authenticationService.closeWrapperDialog.next({ authentication: false });
        this.router.navigateByUrl('/privacy_policy');
    }
}
